
import Modal from '../Modal/index.vue'
export default {
  components: { Modal },
  props: {
    files: {
      default: () => [],
    },
    type: {
      default: 1,
    },
    percent: {
      default: 0,
    },
    uploading: {
      default: false,
    },
  },
  data() {
    return {
      alertBox: { status: false, message: '', variant: '' },
      activeAssignment: {},
      removeConfirmModal: false,
      loading: false,
    }
  },

  methods: {
    async REMOVE_FILE(item, index, childIndex) {
      this.loading = true
      this.alertBox.status = false
      const response = await this.$api.delete(`UserAssignments/${item.id}`)
      if (response.message === 'OK') {
        this.$emit('delete:file', index, childIndex)
        this.alertBox = {
          status: true,
          message: this.$custom$t('fileIsRemoved'),
          variant: 'success',
        }
        this.removeConfirmModal = false
        setTimeout(() => {
          this.activeAssignment = {}
        }, 150)
      } else {
        this.alertBox = {
          status: true,
          message: this.$custom$t('fileIsNotRemoved'),
          variant: 'danger',
        }
      }
      setTimeout(() => {
        this.alertBox.status = false
      }, 2500)
      this.loading = false
    },
    async DOWNLOAD_FILE(file) {
      if (file.filePath.includes('eocademy/Assignments')) {
        const response = await this.$api.get(
          'UserAssignments/DownloadFile?userAssignmentId=' + file.id
        )
        if (response.message === 'OK') {
          window.open(response.data.fileUrl, '_blank')
        }
      }
    },
    formatter(date) {
      if (!!date) return ''
      return this.$date.format(date)
    },
    timeIsExpired(date) {
      if (this.type === 1 || this.type === 3) return false
      return this.$date.getTimeWithoutOffset(date) < new Date().getTime()
    },
    SET_REMOVE_FILE(item, i, j) {
      this.activeAssignment = { ...item, index: i, childIndex: j }
      this.removeConfirmModal = true
    },
    UPLOAD_ASSIGNMENT_FILE(item, index) {
      this.activeAssignment = { ...item, index }
      this.$refs.image.click()
    },
    SET_FILE(e) {
      const files = e.target.files
      this.$emit(
        'response:file',
        files,
        this.activeAssignment.id,
        this.activeAssignment.index
      )
    },
  },
}
